import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { createGetStaticPropsWithPage } from '../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { IFlightsPageData } from '../../features/flights/overview/domain/models/IFlightsPageData';
import { FlightsPage } from '../../features/flights/overview/ui/FlightsPage';
import { getFlightsEnrichmentData } from '../../features/flights/shared/flight/domain/use-cases/getFlightsEnrichmentData';
import { defaultLocale as locale } from '../../features/shared/i18n/locale/constants/default';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IFlightsPageData> =
	createGetStaticPropsWithPage(PassengersPageId.Flights, {
		flightsEnrichmentData: () => getFlightsEnrichmentData(locale),
	});

export default FlightsPage;
